export default __webpack_public_path__ + "static/media/analytics-gray.41e3064a.svg";